/**
 * @generated SignedSource<<3109149276b986eaf0299498538eb4cd>>
 * @relayHash 18644583dc162084508502df5d9d10a2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6f47846f5a71e03a8d1c2c0eba57b4116f4d3d9acb67d9cb6a6b27d0d301d0c6

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PTGraphQLPageStatus = "CURRENT" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type DualStreamQueriesFirstPageQuery$variables = {
  cloudId: string;
  contentId: string;
  first?: number | null;
  includeArchiveFolderSupport?: boolean | null;
  includeAutomationDiscovery?: boolean | null;
  includeDevDocsSyncStatus?: boolean | null;
  includeFolderSummary?: boolean | null;
  includeJiraPlannerConnection?: boolean | null;
  parentId: string;
  spaceKey?: string | null;
};
export type DualStreamQueriesFirstPageQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly emojiTitlePublished: string | null;
      readonly id: string;
      readonly links: {
        readonly webui: string | null;
      } | null;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly status: PTGraphQLPageStatus | null;
      readonly subType: string | null;
      readonly title: string | null;
      readonly type: string | null;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    } | null;
  } | null;
  readonly folderViewActions?: {
    readonly " $fragmentSpreads": FragmentRefs<"FolderViewActions_query">;
  } | null;
  readonly folders: {
    readonly nodes: ReadonlyArray<{
      readonly emojiTitlePublished: string | null;
      readonly id: string;
      readonly links: {
        readonly webui: string | null;
      } | null;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly status: PTGraphQLPageStatus | null;
      readonly subType: string | null;
      readonly title: string | null;
      readonly type: string | null;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    } | null;
  } | null;
  readonly ptpage: {
    readonly id: string;
    readonly subType: string | null;
    readonly title: string | null;
    readonly type: string | null;
  } | null;
  readonly singleContent: {
    readonly body?: {
      readonly storage: {
        readonly value: string | null;
      } | null;
    } | null;
    readonly contentProperties: {
      readonly latest: {
        readonly coverPicture: string | null;
      } | null;
    } | null;
    readonly devDocsOwnershipProperties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
      } | null> | null;
    } | null;
    readonly devDocsProperties?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
    readonly jiraPlannerConnection?: {
      readonly nodes: ReadonlyArray<{
        readonly key: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
    readonly operations: ReadonlyArray<{
      readonly operation: string | null;
      readonly targetType?: string | null;
    } | null> | null;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
    readonly status?: string | null;
    readonly subType?: string | null;
    readonly title?: string | null;
    readonly version?: {
      readonly number: number | null;
    } | null;
  } | null;
};
export type DualStreamQueriesFirstPageQuery = {
  response: DualStreamQueriesFirstPageQuery$data;
  variables: DualStreamQueriesFirstPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": 100,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeArchiveFolderSupport"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAutomationDiscovery"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeDevDocsSyncStatus"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeFolderSummary"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeJiraPlannerConnection"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "parentId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = {
  "kind": "ScalarField",
  "name": "title"
},
v12 = {
  "kind": "ScalarField",
  "name": "type"
},
v13 = {
  "kind": "ScalarField",
  "name": "subType"
},
v14 = {
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "parentId"
    },
    {
      "kind": "Literal",
      "name": "status",
      "value": [
        "CURRENT",
        "DRAFT"
      ]
    }
  ],
  "concreteType": "PTPage",
  "kind": "LinkedField",
  "name": "ptpage",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/)
  ]
},
v15 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v16 = {
  "kind": "ScalarField",
  "name": "status"
},
v17 = {
  "condition": "includeArchiveFolderSupport",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v16/*: any*/),
    (v11/*: any*/),
    (v13/*: any*/)
  ]
},
v18 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "condition": "includeArchiveFolderSupport",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "targetType"
        }
      ]
    }
  ]
},
v19 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "coverPicture"
        }
      ]
    }
  ]
},
v20 = {
  "kind": "ScalarField",
  "name": "value"
},
v21 = {
  "condition": "includeFolderSummary",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "Version",
      "kind": "LinkedField",
      "name": "version",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "number"
        }
      ]
    },
    {
      "concreteType": "ContentBodyPerRepresentation",
      "kind": "LinkedField",
      "name": "body",
      "plural": false,
      "selections": [
        {
          "concreteType": "ContentBody",
          "kind": "LinkedField",
          "name": "storage",
          "plural": false,
          "selections": [
            (v20/*: any*/)
          ]
        }
      ]
    }
  ]
},
v22 = {
  "kind": "ScalarField",
  "name": "key"
},
v23 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v10/*: any*/),
      (v22/*: any*/),
      (v20/*: any*/)
    ]
  }
],
v24 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "smartFolderProperties"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v23/*: any*/),
  "storageKey": "properties(keys:[\"smartFolderProperties\"])"
},
v25 = {
  "condition": "includeJiraPlannerConnection",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "jiraPlannerConnection",
      "args": [
        {
          "kind": "Literal",
          "name": "keys",
          "value": [
            "jira-planner-connection"
          ]
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": [
        {
          "concreteType": "JsonContentProperty",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v22/*: any*/),
            (v20/*: any*/)
          ]
        }
      ],
      "storageKey": "properties(keys:[\"jira-planner-connection\"])"
    }
  ]
},
v26 = [
  {
    "kind": "Literal",
    "name": "keys",
    "value": [
      "devdocsProperties"
    ]
  }
],
v27 = {
  "alias": "devDocsOwnershipProperties",
  "args": (v26/*: any*/),
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v10/*: any*/),
        (v22/*: any*/)
      ]
    }
  ],
  "storageKey": "properties(keys:[\"devdocsProperties\"])"
},
v28 = {
  "condition": "includeDevDocsSyncStatus",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "devDocsProperties",
      "args": (v26/*: any*/),
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": (v23/*: any*/),
      "storageKey": "properties(keys:[\"devdocsProperties\"])"
    }
  ]
},
v29 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v30 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v31 = {
  "kind": "Variable",
  "name": "parentId",
  "variableName": "parentId"
},
v32 = {
  "kind": "Variable",
  "name": "spaceKey",
  "variableName": "spaceKey"
},
v33 = [
  (v29/*: any*/),
  (v30/*: any*/),
  (v31/*: any*/),
  (v32/*: any*/),
  {
    "kind": "Literal",
    "name": "type",
    "value": "FOLDER"
  }
],
v34 = {
  "kind": "ScalarField",
  "name": "emojiTitlePublished"
},
v35 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v36 = {
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v23/*: any*/)
},
v37 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    },
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v38 = [
  {
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v10/*: any*/),
      (v11/*: any*/),
      (v16/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v34/*: any*/),
      (v35/*: any*/),
      (v36/*: any*/)
    ]
  },
  (v37/*: any*/)
],
v39 = [
  (v29/*: any*/),
  (v30/*: any*/),
  (v31/*: any*/),
  (v32/*: any*/),
  {
    "kind": "Literal",
    "name": "type",
    "value": "CONTENT"
  }
],
v40 = [
  {
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      (v10/*: any*/),
      (v11/*: any*/),
      (v16/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v34/*: any*/),
      (v35/*: any*/),
      (v36/*: any*/)
    ]
  },
  (v37/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "name": "DualStreamQueriesFirstPageQuery",
    "selections": [
      {
        "condition": "includeAutomationDiscovery",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "contentId",
                      "variableName": "contentId"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "FolderViewActions_query"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "folderViewActions"
          }
        ]
      },
      (v14/*: any*/),
      {
        "args": (v15/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v21/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v27/*: any*/),
          (v28/*: any*/)
        ]
      },
      {
        "alias": "folders",
        "args": (v33/*: any*/),
        "concreteType": "ConfluenceContentTreeItemConnection",
        "kind": "LinkedField",
        "name": "confluence_contentTreeChildren",
        "plural": false,
        "selections": (v38/*: any*/)
      },
      {
        "alias": "content",
        "args": (v39/*: any*/),
        "concreteType": "ConfluenceContentTreeItemConnection",
        "kind": "LinkedField",
        "name": "confluence_contentTreeChildren",
        "plural": false,
        "selections": (v38/*: any*/)
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "DualStreamQueriesFirstPageQuery",
    "selections": [
      (v14/*: any*/),
      {
        "args": (v15/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v21/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v27/*: any*/),
          (v28/*: any*/),
          (v10/*: any*/)
        ]
      },
      {
        "alias": "folders",
        "args": (v33/*: any*/),
        "concreteType": "ConfluenceContentTreeItemConnection",
        "kind": "LinkedField",
        "name": "confluence_contentTreeChildren",
        "plural": false,
        "selections": (v40/*: any*/)
      },
      {
        "alias": "content",
        "args": (v39/*: any*/),
        "concreteType": "ConfluenceContentTreeItemConnection",
        "kind": "LinkedField",
        "name": "confluence_contentTreeChildren",
        "plural": false,
        "selections": (v40/*: any*/)
      },
      {
        "condition": "includeAutomationDiscovery",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "user",
            "args": [
              {
                "kind": "Literal",
                "name": "current",
                "value": true
              }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
              {
                "concreteType": "AtlassianUserEmail",
                "kind": "LinkedField",
                "name": "emails",
                "plural": true,
                "selections": [
                  (v20/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "isPrimary"
                  }
                ]
              },
              (v10/*: any*/)
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
          },
          {
            "args": (v15/*: any*/),
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "ancestors",
                "plural": true,
                "selections": [
                  (v10/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "18644583dc162084508502df5d9d10a2",
    "id": "6f47846f5a71e03a8d1c2c0eba57b4116f4d3d9acb67d9cb6a6b27d0d301d0c6",
    "metadata": {},
    "name": "DualStreamQueriesFirstPageQuery",
    "operationKind": "query",
    "text": "query DualStreamQueriesFirstPageQuery($cloudId:ID!,$parentId:ID!,$spaceKey:String,$contentId:ID!,$first:Int=100,$includeDevDocsSyncStatus:Boolean=false,$includeAutomationDiscovery:Boolean=false,$includeFolderSummary:Boolean=false,$includeArchiveFolderSupport:Boolean=false,$includeJiraPlannerConnection:Boolean=false){...FolderViewActions_query_3SK5LQ@include(if:$includeAutomationDiscovery),ptpage(id:$parentId,status:[CURRENT,DRAFT]){id,title,type,subType},singleContent(id:$contentId){status@include(if:$includeArchiveFolderSupport)\n    title@include(if:$includeArchiveFolderSupport)\n    subType@include(if:$includeArchiveFolderSupport),operations{operation,targetType@include(if:$includeArchiveFolderSupport)},contentProperties{latest{coverPicture}},version@include(if:$includeFolderSummary){number}\n    body@include(if:$includeFolderSummary){storage{value}},properties(keys:[\"smartFolderProperties\"]){nodes{id,key,value}},jiraPlannerConnection:properties(keys:[\"jira-planner-connection\"])@include(if:$includeJiraPlannerConnection){nodes{key,value}},devDocsOwnershipProperties:properties(keys:[\"devdocsProperties\"]){nodes{id,key}},devDocsProperties:properties(keys:[\"devdocsProperties\"])@include(if:$includeDevDocsSyncStatus){nodes{id,key,value}},id},folders:confluence_contentTreeChildren(cloudId:$cloudId,parentId:$parentId,spaceKey:$spaceKey,type:FOLDER,first:$first){nodes{__typename,id,title,status,type,subType,emojiTitlePublished,links{webui},properties{nodes{id,key,value}}},pageInfo{hasNextPage,endCursor}},content:confluence_contentTreeChildren(cloudId:$cloudId,parentId:$parentId,spaceKey:$spaceKey,type:CONTENT,first:$first){nodes{__typename,id,title,status,type,subType,emojiTitlePublished,links{webui},properties{nodes{id,key,value}}},pageInfo{hasNextPage,endCursor}}}fragment AutomationActionsMenu_query_3SK5LQ on Query{...useKeepUpToDateAction_query_3SK5LQ}fragment FolderViewActions_query_3SK5LQ on Query{...AutomationActionsMenu_query_3SK5LQ}fragment useKeepUpToDateAction_query_3SK5LQ on Query{user:confluence_atlassianUser(current:true){emails{value,isPrimary},id},singleContent(id:$contentId){ancestors{id},id}}"
  }
};
})();

(node as any).hash = "fde8fffa3cce30051905c4e27577cb19";

export default node;
